import {lazy, Suspense} from "react";
import { PageSkeleton } from "../../customs/skeleton/main";


const Main = lazy(() => import("../../components/application/upgradeMemberLevel/main"));

const UpgradeMembership = () => {

    return(

        <Suspense fallback={<PageSkeleton />}>
            <Main/>
        </Suspense>
      
    )
};

export default UpgradeMembership;